import React from 'react';
import { useTranslation } from 'react-i18next';
import { VotingSession, User } from '../../types';
import { formatDateTime, formatDurationMinutes } from '../../utils/format';
import SessionResults from './SessionResults';

interface ServerHistoryListProps {
  sessions: VotingSession[];
  participants: User[];
  expandedId: string | null;
  onToggle: (id: string) => void;
}

/** Sessions the backend recorded for this room, fetched from the server. */
const ServerHistoryList: React.FC<ServerHistoryListProps> = ({
  sessions,
  participants,
  expandedId,
  onToggle,
}) => {
  const { t } = useTranslation();

  if (sessions.length === 0) {
    return (
      <div className="no-sessions">
        <p>{t('history.noSessionHistory') || 'まだセッション履歴がありません'}</p>
      </div>
    );
  }

  return (
    <div className="sessions-list">
      {sessions.map((session) => (
        <div key={session.id} className="session-item">
          <div className="session-header" onClick={() => onToggle(session.id)}>
            <div className="session-info">
              <h4 className="session-title">{session.story_title}</h4>
              <div className="session-meta">
                <span className="session-date">{formatDateTime(session.created_at)}</span>
                <span className="session-duration">
                  {session.finished_at
                    ? formatDurationMinutes(session.created_at, session.finished_at)
                    : '進行中'}
                </span>
                <span className={`session-status ${session.is_revealed ? 'completed' : 'pending'}`}>
                  {session.is_revealed ? (t('room.results.votingResults') || '完了') : (t('room.voting.waitingForVotes') || '進行中')}
                </span>
              </div>
            </div>
            <div className="session-toggle">{expandedId === session.id ? '▼' : '▶'}</div>
          </div>

          {expandedId === session.id && (
            <div className="session-details">
              {session.story_description && (
                <div className="session-description">
                  <strong>{t('room.currentSession') || '説明'}:</strong> {session.story_description}
                </div>
              )}
              <SessionResults sessionId={session.id} participants={participants} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ServerHistoryList;
